<script>
    import Header from "../components/Header.svelte";
    import { company_info, api_host, domain_code_store } from "../stores.js";
    import Button, { Label } from '@smui/button/styled';
    import Textfield from '@smui/textfield/styled';
    import HelperText from '@smui/textfield/helper-text/index';
    import CharacterCounter from '@smui/textfield/character-counter/index';
    import Select, { Option } from '@smui/select/styled';
    import { doFetch } from '../utils/Fetching.svelte';
    import { toast } from '@zerodevx/svelte-toast';
    import { toast_message } from '../utils/toast_message.js';
    import * as yup from 'yup';


    let domain_code = '';
    domain_code_store.subscribe(value => { domain_code = value; });

    $: full_name = `${field_data.first_name} ${field_data.last_name}`;
    $: full_address = `${field_data.street_address}, ${field_data.city}, ${field_data.state} ${field_data.zipcode}`;

    let apply_as = ['Employee', 'Contractor'];
    let business_structure_options = ["N/A", "Sole Proprietorship", "LLC", "Other"];
    let best_time_to_call_options = ['Anytime', 'Morning', 'Afternoon', 'Night'];
    let time_availability_options = ['Part-Time', 'Full-Time'];
    let authorized_to_work_options = ['Yes', 'No'];
    let insured_options = ['Yes', 'No'];
    let english_fluency_options = ['Yes', 'No'];
    let has_truck_options = ['Yes', 'No'];
    let has_internet_options = ['Yes', 'No'];
    let has_smartphone_options = ['Yes', 'No'];
    
    let lawn_equipment = "";
    let how_did_you_hear = "";
    let additional_comments = "";

    let disable_send = false;

    const formSchema = yup.object().shape({
        first_name: yup
            .string()
            .required('First Name is Required'),
        last_name: yup
            .string()
            .required('Last Name is Required'),
        email: yup.string().required('This Field is Required').email('Invalid email'),
        home_phone: yup
            .string()
                .required('Home Phone is Required')
                .matches(/(?:\d{1}\s)?\(?(\d{3})\)?-?\s?(\d{3})-?\s?(\d{4})/, {
                    message: 'Invalid phone number',
                }),
            // .string()
            // .test('mobile-is-good', 'Invalid phone number.', value => {return (value === null || value.match(/^ *$/) !== null) || (value.match(/(?:\d{1}\s)?\(?(\d{3})\)?-?\s?(\d{3})-?\s?(\d{4})/));}),
        mobile_phone: yup
            .string()
            .required('Mobile Phone is Required')
            .matches(/(?:\d{1}\s)?\(?(\d{3})\)?-?\s?(\d{3})-?\s?(\d{4})/, {
                message: 'Invalid phone number',
            }),
        street_address: yup
            .string()
            .required('Street address is Required'),
        city: yup
            .string()
            .required('City is Required'),
        state: yup
            .string()
            .required('State Code is Required')
            .matches(
                /^[a-zA-Z]{2}$/,
                'Code must be a 2 character state abbrev.'
            ),
        zipcode: yup
            .string()
            .required('Zip Code Required')
            .matches(
                /^[0-9]{5}$/,
                'Code must be a 5 digit number.'
            ),
        business_structure: yup
            .string()
            .required('This field is Required'),
        best_time_to_call: yup
            .string()
            .required('This field is Required'),
        time_availability: yup
            .string()
            .required('This field is Required'),
        years_of_experience: yup
            .string()
            .required('This field is Required')
            .matches(/^[0-9]*$/),
        authorized_to_work: yup
            .string()
            .required('This field is Required'),
        insured: yup
            .string()
            .required('This field is Required'),
        english_fluency: yup
            .string()
            .required('This field is Required'),
        has_truck: yup
            .string()
            .required('This field is Required'),
        has_internet: yup
            .string()
            .required('This field is Required'),
        has_smartphone: yup
            .string()
            .required('This field is Required'),
    });

    // load up watched fields
    let field_data = {};
    for (let nk in formSchema.describe().fields){
        field_data[nk] = "";
        field_data[`${nk}_iv`] = false;
        field_data[`${nk}_h`] = "";
        field_data[`${nk}_valid_need`] = true;
    }
    // reset error flags
    function resetFieldData() {
        for (let nk in formSchema.describe().fields){
            field_data[`${nk}_iv`] = false;
            field_data[`${nk}_h`] = "";
        }
    }

    async function validateForm(){
        if (field_data.role === 'Employee') {
            console.log('employee!');
            const unnecessary_fields = ['business_structure', 'best_time_to_call', 'time_availability', 'years_of_experience', 'authorized_to_work', 'insured', 'english_fluency', 'has_truck', 'has_internet', 'has_smartphone', 'lawn_equipment'];
            unnecessary_fields.forEach(nk => {
                field_data[`${nk}_valid_need`] = false;
            });
        }

        resetFieldData();
        let res = true;
        for (let nk in formSchema.describe().fields){
            if (field_data[`${nk}_valid_need`]) {
                await formSchema.validateAt(nk, field_data, {
                    abortEarly: true  
                }).catch((err) => {
                    field_data[`${nk}_iv`] = true;
                    field_data[`${nk}_h`] = err.errors[0];
                    res = false;
                });
            }
        }
        return res;
    }

    async function validateSingle(nk) {
        const validateAtRes = await formSchema.validateAt(nk, field_data, {
            abortEarly: true  
        }).then(() => {
            field_data[`${nk}_iv`] = false;
            field_data[`${nk}_h`] = '';
        }).catch((err) => {
            field_data[`${nk}_iv`] = true;
            field_data[`${nk}_h`] = err.errors[0];
        });
    }

    async function send_job_application_email() {
        if (await validateForm()) {
            disable_send = true;
            const payload = {
                first_name: field_data.first_name,
                last_name: field_data.last_name,
                email: field_data.email,
                full_name: full_name,
                home_phone: field_data.home_phone,
                mobile_phone: field_data.mobile_phone,
                street: field_data.street_address,
                city: field_data.city,
                state: field_data.state,
                zipcode: field_data.zipcode,
                profile_type: field_data.role,
                full_address: full_address,
                business_structure: field_data.business_structure,
                best_time_to_call: field_data.best_time_to_call,
                time_availability: field_data.time_availability,
                has_experience: true,
                years_experience: field_data.years_of_experience || 0,
                authorized: field_data.authorized_to_work === 'Yes',
                insured: field_data.insured === 'Yes',
                english_fluency: field_data.english_fluency === 'Yes',
                has_truck: field_data.has_truck === 'Yes',
                internet_access: field_data.has_internet === 'Yes',
                smart_phone: field_data.has_smartphone === 'Yes',
                lawn_equipment: lawn_equipment || '',
                hear_about_us: how_did_you_hear,
                additional_comments: additional_comments,
                internal_comments: '',
                carrier: '',
                password: '1qaz@WSX',
                role: 'applicant'
            };

            const res = await doFetch(
                `${api_host}/api/create/applicant`,
                'POST',
                payload,
                { 'Content-Type': 'application/json', 'DomainCode': domain_code }
            );
            if (res.status) {
                toast_message(true, res.msg, 3000);
                field_data.first_name = "";
                field_data.last_name = "";
                field_data.email = "";
                field_data.home_phone = "";
                field_data.mobile_phone = "";
                field_data.street_address = "";
                field_data.city = "";
                field_data.state = "";
                field_data.zipcode = "";
                field_data.business_structure = "";
                field_data.best_time_to_call = "";
                field_data.time_availability = "";
                field_data.years_of_experience = "";
                field_data.authorized_to_work = "";
                field_data.insured = "";
                field_data.english_fluency = "";
                field_data.has_truck = "";
                field_data.has_internet = "";
                field_data.has_smartphone = "";
                lawn_equipment = "";
                how_did_you_hear = "";
                additional_comments = "";
                resetFieldData();
            } else {
                toast_message(false, res.msg || 'Bad request', 3000);
            }

            disable_send = false;
        } else {
            toast.push("Please fill out all required fields", {
                duration: 5000,
                // initial: 0,
                // progress: 0,
                dismissable: false,
                theme: {
                    '--toastBackground': '#F56565',
                    '--toastProgressBackground': '#C53030'
                }
            });
        }
    }
</script>

<Header />

<div class="formholder">
    <div class="pagetitle">
        Jobs Application
    </div>

    <div class="preformcontent">

    </div>

    <div class="sectiontitle informationtitle">Information</div>

    <div class="ff firstname">
        <Textfield 
            required
            style="width: 100%;"
            helperLine$style="width: 100%;" 
            variant="outlined" 
            invalid={field_data.first_name_iv}
            bind:value={field_data.first_name}
            label="First Name"
            on:input={() => {validateSingle('first_name')}}
            on:blur={() => {validateSingle('first_name')}}
        >
            <HelperText validationMsg=true persistent=true slot="helper">{field_data.first_name_h}</HelperText>
        </Textfield>            
    </div>

    <div class="ff lastname">
        <Textfield 
            required
            style="width: 100%;"
            helperLine$style="width: 100%;" 
            variant="outlined" 
            invalid={field_data.last_name_iv}
            bind:value={field_data.last_name}
            label="Last Name"
            on:input={() => {validateSingle('last_name')}}
            on:blur={() => {validateSingle('last_name')}}
        >
            <HelperText validationMsg=true persistent=true slot="helper">{field_data.last_name_h}</HelperText>
        </Textfield>            
    </div>

    <div class="ff email">
        <Textfield
            type="email"
            required
            style="width: 100%;"
            helperLine$style="width: 100%;" 
            variant="outlined" 
            invalid={field_data.email_iv}
            bind:value={field_data.email}
            label="Email"
            on:input={() => {validateSingle('email')}}
            on:blur={() => {validateSingle('email')}}
        >
            <HelperText validationMsg=true persistent=true slot="helper">{field_data.email_h}</HelperText>
        </Textfield>            
    </div>

    <div class="ff homephone">
        <Textfield 
            style="width: 100%;"
            helperLine$style="width: 100%;" 
            variant="outlined" 
            invalid={field_data.home_phone_iv}
            bind:value={field_data.home_phone}
            label="Home Phone"
            on:input={() => {validateSingle('home_phone')}}
            on:blur={() => {validateSingle('home_phone')}}
        >
            <HelperText validationMsg=true persistent=true slot="helper">{field_data.home_phone_h}</HelperText>
        </Textfield>            
    </div>

    <div class="ff mobilephone">
        <Textfield 
            style="width: 100%;"
            required
            helperLine$style="width: 100%;" 
            variant="outlined" 
            invalid={field_data.mobile_phone_iv}
            bind:value={field_data.mobile_phone}
            label="Mobile Phone"
            on:input={() => {validateSingle('mobile_phone')}}
            on:blur={() => {validateSingle('mobile_phone')}}
        >
            <HelperText validationMsg=true persistent=true slot="helper">{field_data.mobile_phone_h}</HelperText>
        </Textfield>            
    </div>

    <div class="sectiontitle addresstitle">Address</div>

    <div class="ff street">
        <Textfield 
            style="width: 100%;"
            required
            helperLine$style="width: 100%;" 
            variant="outlined" 
            invalid={field_data.street_address_iv}
            bind:value={field_data.street_address}
            label="Street Address"
            on:input={() => {validateSingle('street_address')}}
            on:blur={() => {validateSingle('street_address')}}
        >
            <HelperText validationMsg=true persistent=true slot="helper">{field_data.street_address_h}</HelperText>
        </Textfield>            
    </div>

    <div class="ff city">
        <Textfield 
            style="width: 100%;"
            required
            helperLine$style="width: 100%;" 
            variant="outlined" 
            invalid={field_data.city_iv}
            bind:value={field_data.city}
            label="City"
            on:input={() => {validateSingle('city')}}
            on:blur={() => {validateSingle('city')}}
        >
            <HelperText validationMsg=true persistent=true slot="helper">{field_data.city_h}</HelperText>
        </Textfield>            
    </div>

    <div class="ff state">
        <Textfield 
            style="width: 100%;"
            required
            helperLine$style="width: 100%;" 
            variant="outlined" 
            invalid={field_data.state_iv}
            bind:value={field_data.state}
            label="State"
            on:input={() => {validateSingle('state')}}
            on:blur={() => {validateSingle('state')}}
        >
            <HelperText validationMsg=true persistent=true slot="helper">{field_data.state_h}</HelperText>
        </Textfield>            
    </div>

    <div class="ff zipcode">
        <Textfield 
            type="number"
            style="width: 100%;"
            required
            helperLine$style="width: 100%;" 
            variant="outlined" 
            invalid={field_data.zipcode_iv}
            bind:value={field_data.zipcode}
            label="Zip Code"
            on:input={() => {validateSingle('zipcode')}}
            on:blur={() => {validateSingle('zipcode')}}
        >
            <HelperText validationMsg=true persistent=true slot="helper">{field_data.zipcode_h}</HelperText>
        </Textfield>            
    </div>

    <div class="sectiontitle applyastitle">Apply as</div>
    <div class="ff applyas">
        <Select 
            variant="outlined" 
            required
            style="width: 100%;"
            invalid={field_data.role_iv}
            bind:value={field_data.role} 
            label="Apply as"
        >
            {#each apply_as as aa}
                <Option value={aa}>{aa}</Option>
            {/each}
        </Select>
    </div>

    {#if field_data.role === 'Contractor'}
    <div class="sectiontitle businessstructuretitle">Business Structure</div>
    <div class="ff businessstructure">
        <Select 
            variant="outlined" 
            required
            style="width: 100%;"
            invalid={field_data.business_structure_iv}
            bind:value={field_data.business_structure} 
            label="Business Structure"
        >
            {#each business_structure_options as bso}
                <Option value={bso}>{bso}</Option>
            {/each}
        </Select>
    </div>
    {/if}

    <div class="sectiontitle contactinformationtitle">Additional Information</div>
    {#if field_data.role === 'Contractor'}
    <div class="ff besttimetocall">
        <Select 
            variant="outlined" 
            required
            style="width: 100%;"
            invalid={field_data.best_time_to_call_iv}
            bind:value={field_data.best_time_to_call} 
            label="Best Time To Call"
        >
            {#each best_time_to_call_options as bto}
                <Option value={bto}>{bto}</Option>
            {/each}
        </Select>
    </div>
        
    <div class="ff timeavailability">
        <Select 
            variant="outlined" 
            required
            style="width: 100%;"
            invalid={field_data.time_availability_iv}
            bind:value={field_data.time_availability} 
            label="Time Availability"
        >
            {#each time_availability_options as tao}
                <Option value={tao}>{tao}</Option>
            {/each}
        </Select>
    </div>

    <div class="ff yearsofexperience">
        <Textfield 
            type="number"
            style="width: 100%;"
            required
            helperLine$style="width: 100%;" 
            variant="outlined" 
            invalid={field_data.years_of_experience_iv}
            bind:value={field_data.years_of_experience}
            label="Years of experience"
            on:input={() => {validateSingle('years_of_experience')}}
            on:blur={() => {validateSingle('years_of_experience')}}
        >
            <HelperText validationMsg=true persistent=true slot="helper">{field_data.years_of_experience_h}</HelperText>
        </Textfield>         
    </div>
        
    <div class="ff authorizedtowork">
        <Select 
            variant="outlined" 
            required
            style="width: 100%;"
            invalid={field_data.authorized_to_work_iv}
            bind:value={field_data.authorized_to_work} 
            label="Authorized to work"
        >
            {#each authorized_to_work_options as awo}
                <Option value={awo}>{awo}</Option>
            {/each}
        </Select>
    </div>
        
    <div class="ff insured">
        <Select 
            variant="outlined" 
            required
            style="width: 100%;"
            invalid={field_data.insured_iv}
            bind:value={field_data.insured} 
            label="Insured"
        >
            {#each insured_options as io}
                <Option value={io}>{io}</Option>
            {/each}
        </Select>
    </div>
        
    <div class="ff englishfluency">
        <Select 
            variant="outlined" 
            required
            style="width: 100%;"
            invalid={field_data.english_fluency_iv}
            bind:value={field_data.english_fluency} 
            label="English Fluency"
        >
            {#each english_fluency_options as efo}
                <Option value={efo}>{efo}</Option>
            {/each}
        </Select>
    </div>
        
    <div class="ff hastruck">
        <Select 
            required
            variant="outlined" 
            style="width: 100%;"
            invalid={field_data.has_truck_iv}
            bind:value={field_data.has_truck} 
            label="Do you have a truck?"
        >
            {#each has_truck_options as hto}
                <Option value={hto}>{hto}</Option>
            {/each}
        </Select>
    </div>
        
    <div class="ff hasinternet">
        <Select 
            required
            variant="outlined" 
            style="width: 100%;"
            invalid={field_data.has_internet_iv}
            bind:value={field_data.has_internet} 
            label="Do you have Internet access?"
        >
            {#each has_internet_options as hio}
                <Option value={hio}>{hio}</Option>
            {/each}
        </Select>
    </div>
        
    <div class="ff hassmartphone">
        <Select 
            required
            variant="outlined" 
            style="width: 100%;"
            invalid={field_data.has_smartphone_iv}
            bind:value={field_data.has_smartphone} 
            label="Do you have a smartphone?"
        >
            {#each has_smartphone_options as hso}
                <Option value={hso}>{hso}</Option>
            {/each}
        </Select>
    </div>

    <div class="ff tb lawnequipment">
        <Textfield 
            textarea 
            input$maxlength="1000" 
            style="width: 100%; height: 100%"
            bind:value={lawn_equipment} 
            label="What kind of lawn care equipment, such as lawn mower, trimmer do you own?"
        >
            <CharacterCounter slot="internalCounter">0 / 1000</CharacterCounter>
        </Textfield>
    </div>
    {/if}

    <div class="ff tb howdidyouhear">
        <Textfield 
            textarea 
            input$maxlength="1000" 
            style="width: 100%; height: 100%"
            bind:value={how_did_you_hear} 
            label="How did you hear about {$company_info.name}?"
        >
            <CharacterCounter slot="internalCounter">0 / 1000</CharacterCounter>
        </Textfield>
    </div>

    <div class="ff tb additionalcomments">
        <Textfield 
            textarea 
            input$maxlength="1000" 
            style="width: 100%; height: 100%"
            bind:value={additional_comments} 
            label="Additional Comments"
        >
            <CharacterCounter slot="internalCounter">0 / 1000</CharacterCounter>
        </Textfield>
    </div>

    <div class="ff buttonbar">
        <Button
            disabled={disable_send}
            on:click={() => {send_job_application_email()}} 
            variant="raised" 
            class="button-shaped-round"
        >Send Now</Button>
    </div>
</div>

<style>
    /* globals */
    .ff {
        padding: 10px;
    }
    .sectiontitle {
        font-size: 20px;
        border-bottom: solid 1px #ccc;
        margin-top: 20px;
    }
    .tb {
        height: 200px;
    }
    .formholder {
        width: 80%;
        margin-left: auto;
        margin-right: auto;
        display: grid;
        gap: 10px;
        grid-template-columns: repeat(12, 1fr);
        grid-template-areas: "pt pt pt pt pt pt pt pt pt pt pt pt"
                             "pc pc pc pc pc pc pc pc pc pc pc pc"
                             "it it it it it it at at at at at at"
                             "fn fn fn ln ln ln sr sr sr sr sr sr"
                             "em em em em em em ct ct st st zp zp"
                             "hp hp hp mp mp mp cw cw cw cw cw cw"
                             "rt rt rt rt rt rt rt rt rt rt rt rt"
                             "aa aa aa aa aa aa aa aa aa aa aa aa"
                             "bt bt bt bt bt bt bt bt bt bt bt bt"
                             "bs bs bs bs bs bs bs bs bs bs bs bs"
                             "ot ot ot ot ot ot ot ot ot ot ot ot"
                             "tc tc tc tc ta ta ta ta ye ye ye ye"
                             "aw aw aw aw is is is is ef ef ef ef"
                             "ht ht ht ht hi hi hi hi hs hs hs hs"
                             "le le le le le le le le le le le le"
                             "hd hd hd hd hd hd hd hd hd hd hd hd"
                             "ac ac ac ac ac ac ac ac ac ac ac ac"
                             "bb bb bb bb .  .  .  .  .  .  .  . ";
    }
    @media (max-device-width: 1024px), (max-width: 1023px) {
        .formholder {
            width: 90%;
            margin-left: auto;
            margin-right: auto;
            display: grid;
            grid-template-columns: 1fr;
            grid-template-areas: "pt"
                                 "pc"
                                 "it"
                                 "fn"
                                 "ln"
                                 "em"
                                 "hp"
                                 "rt"
                                 "aa"
                                 "mp"
                                 "at"
                                 "sr"
                                 "ct"
                                 "st"
                                 "zp"
                                 "cw"
                                 "bt"
                                 "bs"
                                 "ot"
                                 "tc"
                                 "ta"
                                 "ye"
                                 "aw"
                                 "is"
                                 "ef"
                                 "ht"
                                 "hi"
                                 "hs"
                                 "le"
                                 "hd"
                                 "ac"
                                 "bb";
        }
    }
    .pagetitle {
        grid-area: pt;
        border-bottom: solid 1px #E9E9EC;
        font-size: 3rem;
        font-weight: bold;
    }
    .preformcontent {
        grid-area: pc;
        padding: 10px;
    }
    .informationtitle {
        grid-area: it;
    }
    .firstname {
        grid-area: fn;
    }
    .lastname {
        grid-area: ln;
    }
    .email {
        grid-area: em;
    }
    .homephone {
        grid-area: hp;
    }
    .mobilephone {
        grid-area: mp;
    }
    .addresstitle {
        grid-area: at;
    }
    .street {
        grid-area: sr;
    }
    .city {
        grid-area: ct;
    }
    .state {
        grid-area: st;
    }
    .zipcode {
        grid-area: zp;
    }
    .businessstructuretitle{
        grid-area: bt;
    }
    .businessstructure {
        grid-area: bs;
    }
    .applyastitle {
        grid-area: rt;
    }
    .applyas {
        grid-area: aa;
    }
    .contactinformationtitle {
        grid-area: ot;
    }
    .besttimetocall {
        grid-area: tc;
    }
    .timeavailability {
        grid-area: ta;
    }
    .yearsofexperience {
        grid-area: ye;
    }
    .authorizedtowork {
        grid-area: aw;
    }
    .insured {
        grid-area: is;
    }
    .englishfluency {
        grid-area: ef;
    }
    .hastruck {
        grid-area: ht;
    }
    .hasinternet {
        grid-area: hi;
    }
    .hassmartphone {
        grid-area: hs;
    }
    .lawnequipment {
        grid-area: le;
    }
    .howdidyouhear {
        grid-area: hd;
    }
    .additionalcomments {
        grid-area: ac;
    }
    .buttonbar {
        grid-area: bb;
    }
</style>